import React from "react";

import img from "images/banner/04.jpg";

const Sidebar = () => {
	return (
		<div id="side-bar" className="side-bar header-two">
			<button
				className="close-icon-menu"
				onClick={() => {
					document.getElementById("anywhere-home").classList.remove("bgshow");
					document.getElementById("side-bar").classList.remove("show");
				}}>
				<i className="far fa-times"></i>
			</button>

			<div className="inner-main-wrapper-desk">
				<div className="thumbnail">
					<img src={img} alt="elevate" />
				</div>
				<div className="inner-content">
					<h4 className="title">Cartongesso, isolamento e ristrutturazioni a Codogno.</h4>
					<p className="disc">Trasforma i tuoi spazi con cartongesso su misura.</p>
					<div className="footer">
						<h4 className="title">Hai un progetto?</h4>
						<a
							href="#contact"
							className="rts-btn btn-primary"
							onClick={() => {
								document.getElementById("anywhere-home").classList.remove("bgshow");
								document.getElementById("side-bar").classList.remove("show");
							}}>
							Parliamone!
						</a>
					</div>
				</div>
			</div>

			<div className="mobile-menu-main">
				<nav className="nav-main mainmenu-nav mt--30">
					<ul className="mainmenu metismenu" id="mobile-menu-active">
						<li>
							<a href="#home" className="main">
								Home
							</a>
						</li>
						<li>
							<a href="#about" className="main">
								About
							</a>
						</li>
						<li>
							<a href="#services" className="main">
								Servizi
							</a>
						</li>
						{/* <li>
							<a href="#portfolio" className="main">
								Portfolio
							</a>
						</li>
						<li>
							<a href="#blog" className="main">
								Blog
							</a>
						</li> */}
						<li>
							<a href="#contact" className="main">
								Contatti
							</a>
						</li>
					</ul>
				</nav>

				{/* <div className="rts-social-style-one pl--20 mt--100">
					<ul>
						<li>
							<a href="#">
								<i className="fa-brands fa-facebook-f"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i className="fa-brands fa-twitter"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i className="fa-brands fa-youtube"></i>
							</a>
						</li>
						<li>
							<a href="#">
								<i className="fa-brands fa-linkedin-in"></i>
							</a>
						</li>
					</ul>
				</div> */}
			</div>
		</div>
	);
};

export default Sidebar;
